import { render, staticRenderFns } from "./CompletudeDossier.vue?vue&type=template&id=a1904c32"
import script from "./CompletudeDossier.vue?vue&type=script&lang=js"
export * from "./CompletudeDossier.vue?vue&type=script&lang=js"
import style0 from "./CompletudeDossier.vue?vue&type=style&index=0&id=a1904c32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports